import axiosInstance from '../axiosInterceptor/axiosInstance'
import axios from 'axios'

// Season overlays live under the season's org; the backend checks the season belongs to it.
const base = (orgId, seasonId) => `v1/orgs/${orgId}/seasons/${seasonId}/overlays`

export const getOverlays = (orgId, seasonId) =>
  axiosInstance.get(base(orgId, seasonId)).then((r) => r.data)

// variant selects which board a type resolves to (Team Shots: 1 home, 2 away; every
// other type: 0). The backend defaults it to 0 but rejects a Team Shots write that
// omits it, so callers editing a Team Shots board must always pass it explicitly.
export const upsertOverlay = (orgId, seasonId, type, payload, variant = 0) =>
  axiosInstance.put(`${base(orgId, seasonId)}/${type}`, payload, { params: { variant } }).then((r) => r.data)

export const deleteOverlay = (orgId, seasonId, type, variant = 0) =>
  axiosInstance.delete(`${base(orgId, seasonId)}/${type}`, { params: { variant } })

export const presignSvgUpload = (orgId, seasonId, type, fileName, variant = 0) =>
  axiosInstance
    .post(`${base(orgId, seasonId)}/${type}/presign-upload`, { fileName }, { params: { variant } })
    .then((r) => r.data.uploadUrl)

export const uploadSvgToS3 = (presignedUrl, file) =>
  axios.put(presignedUrl, file, { headers: { 'Content-Type': 'image/svg+xml' } })

export const getOverlayFields = (orgId, seasonId, type, targetMode) =>
  axiosInstance.get(`${base(orgId, seasonId)}/${type}/fields`, { params: { targetMode } }).then((r) => r.data)

// format=html: the backend returns one self-contained text/html document
// with fonts/images inlined as data URIs.
export const previewOverlay = (orgId, seasonId, type, body) =>
  axiosInstance
    .post(`${base(orgId, seasonId)}/${type}/preview`, body, { params: { format: 'html' }, responseType: 'text' })
    .then((r) => r.data)
